import { useCallback, useEffect, useState } from "react";
import { apiMe, type MeUser } from "./api";

export function useSession() {
  const [user, setUser] = useState<MeUser | null | undefined>(undefined);
  const [isAdmin, setIsAdmin] = useState(false);
  const [impersonator, setImpersonator] = useState<{ id: string; email: string } | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const me = await apiMe();
      setUser(me.user);
      setIsAdmin(me.isAdmin === true);
      setImpersonator(me.impersonator ?? null);
    } catch {
      setUser(null);
      setIsAdmin(false);
      setImpersonator(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { user, isAdmin, impersonator, loading, refresh };
}
